import { graphql } from "@/data-access/graphql";
import type { introspection_types } from "@/types/graphql-env.d.ts";

export const AvailableTimezonesQuery = graphql(`
  query availableTimezones {
    availableTimezones {
      __typename
      value
      label
    }
  }
`);

// Generate a type for the Timezones enum from the schema.graphql
export type TimezoneChoices = introspection_types["Timezone"]["enumValues"];
